import { useRecentActivities } from "../../../js/api/activity-feed/get-activities";
import { useRecentActivityFeed } from "../../recent-activity-feed";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../shared/accordion";
import { ErrorContent } from "../shared/error-content";
import { LoadingContent } from "../shared/loading-content";
import { ActivityFeed } from "./activity-feed";
import { useMediaQuery } from "@uidotdev/usehooks";
import { splitActivitiesByDivider } from "./split-activities-by-divider";

const ACTIVITIES_COUNT = 20;
const ACTIVITIES_DIVIDER = 5;

export const RecentActivityFeedWrapper = () => {
  const propsData = useRecentActivityFeed();
  const { data, isLoading, isError, isFetching } = useRecentActivities({
    itemCount: ACTIVITIES_COUNT,
    pageNumber: 1,
    beforeTimestamp: new Date().toISOString(),
  });
  const isAccordionVersion = useMediaQuery(
    "only screen and (max-width : 979px)"
  );

  const isEmpty = !isLoading && !isFetching && !data?.activityFeedsList.length;

  if (isLoading) {
    return <LoadingContent />;
  }

  if (isError) {
    return <ErrorContent />;
  }

  const { shownData, hiddenData } = splitActivitiesByDivider(
    ACTIVITIES_DIVIDER,
    data
  );

  return (
    <>
      {isEmpty && (
        <div className="saved-colors-loading-container saved-colors-loading-container--no-top-padding">
          {propsData.emptyActivitiesMessage}
        </div>
      )}
      {!isEmpty && isAccordionVersion && (
        <>
          <Accordion
            type="single"
            collapsible
          >
            <AccordionItem value="item-1">
              <ActivityFeed
                apiData={shownData}
                contextData={propsData}
              />
              <AccordionContent>
                <ActivityFeed
                  apiData={hiddenData}
                  contextData={propsData}
                />
              </AccordionContent>
              <AccordionTrigger>
                <span className="accordion-trigger-text accordion-trigger-text--open">
                  {propsData?.showLess}
                </span>
                <span className="accordion-trigger-text accordion-trigger-text--closed">
                  {propsData?.showMore}
                </span>
              </AccordionTrigger>
            </AccordionItem>
          </Accordion>
        </>
      )}
      {!isEmpty && !isAccordionVersion && (
        <ActivityFeed
          apiData={data}
          contextData={propsData}
        />
      )}
    </>
  );
};
